<script setup lang="ts">
import type { StoreStockStatusFragment, StoreStockStatusStoreFragment, TtLocationFragment } from '#graphql-operations'

const props = defineProps<{
  store: TtLocationFragment
  storeStock: StoreStockStatusFragment | null
}>()

const stock = computed<StoreStockStatusStoreFragment | null>(() => {
  return props.storeStock?.stores?.find((item: StoreStockStatusStoreFragment | null) => item?.code === props.store.code) || null
})

defineEmits<{
  select: [store: TtLocationFragment]
}>()
</script>

<template>
  <div @click="$emit('select', store)">
    <div class="stores-pickup__store-name">
      {{ store.city }}
    </div>
    <p class="stores-pickup__store-address">
      {{ store.locationLine1 }} {{ store.locationLine2 }}, {{ store.city }}
    </p>
    <div
      v-if="stock !== null"
      class="stores-pickup__availability"
    >
      <span
        class="stores-pickup__availability-bullet"
        :class="stock.status"
      />
      <span v-if="stock.status === 'all-backorder'">{{ $tc(stock.status as string, storeStock?.deliveryTime || 0) }}</span>
      <span v-else-if="stock.status === 'backorder'">{{ $t('checkout-backorder') }}</span>
      <span v-else>{{ $t(stock.status as string) }}</span>
    </div>

    <span class="stores-pickup__reset">{{ $t('wis als favoriet') }}</span>
  </div>
</template>
